// extracted by mini-css-extract-plugin
export default {"codetable-item-form":"codetable-item-form__codetable-item-form--yiLCw","codetableItemForm":"codetable-item-form__codetable-item-form--yiLCw"};